import { connect } from 'react-redux'
import {
  compose, lifecycle, withHandlers, withState,
} from 'recompose'
import { bindActionCreators } from 'redux'
import { updateSiteConfiguration } from 'actions/Site'
import { fetchBannerApps, updateBannerApps } from 'actions/BannerApps'
import FormBannerAppsView from 'components/pages/webManagement/bannerApps/Form'
import { message } from 'antd'
import history from 'utils/history'

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({
  updateSiteConfiguration: bindActionCreators(updateSiteConfiguration, dispatch),
  fetchBannerApps: bindActionCreators(fetchBannerApps, dispatch),
  updateBannerApps: bindActionCreators(updateBannerApps, dispatch),
})


export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('longDesc', 'setLongDesc', ''),
  withState('isSubmit', 'setIsSubmit', false),
  withState('detail', 'setDetail', {
    data: {},
    meta: {},
    isFetching: true,
  }),
  withHandlers({
    getDetail: props => () => {
      props.fetchBannerApps()
        .then((result) => {
          props.setDetail({
            data: result.data,
            meta: result.meta,
            isFetching: false,
          })
        })
        .catch((error) => {
          props.setDetail({
            data: {},
            meta: {},
            isFetching: false,
          })
          message.error(error.message)
        })
    },
  }),
  withHandlers({
    onSubmit: props => (values) => {
      props.setIsSubmit(!props.isSubmit)
      props.updateBannerApps(values)
        .then(() => {
          props.setIsSubmit(!props.isSubmit)
          history.push('/web-management/banner-apps')
        }).catch((err) => {
          message.error(err)
          props.setIsSubmit(!props.isSubmit)
        })
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.updateSiteConfiguration('breadList', ['Home', 'Web Management', 'Banner Apps', 'Form'])
      this.props.updateSiteConfiguration('titlePage', 'Banner Apps Form')
      this.props.getDetail()
    },
  }),
)(FormBannerAppsView)
